import formatters from './formatter';

export default {
    filterDate(date) {
        try {
            return formatters.formatISODate(new Date(date));
        } catch (_) {
            return false;
        }
    },
    getToday(text) {
        const date = new Date();
        const today = new Date(date.getFullYear(), date.getMonth(), date.getDate());

        if (text) {
            return formatters.formatISODate(today);
        }

        return today;
    },
    getMonth(dateString) {
        const date = new Date(dateString);
        return date.getMonth() + 1;
    },
    getWeekday(dateString) {
        const date = new Date(dateString);
        return (date.getDay() + 6) % 7;
    },
    getNextHour(timeString) {
        const time = this.formatTime(timeString);
        const parts = time.split(':');
        const hour = Number.parseInt(parts[0], 10);
        const nextHour = (hour + 1) % 24;

        function pad(number) {
            return `${number}`.padStart(2, '0');
        }

        return `${pad(nextHour)}:${parts[1]}`;
    },
    fromTimeString(timeString) {
        const parts = timeString.split(':');
        let seconds = 0;
        seconds += 3600 * Number.parseInt(parts[0], 10);
        seconds += 60 * Number.parseInt(parts[1], 10);
        if (parts.length > 2) {
            seconds += Number.parseInt(parts[2], 10);
        }

        return seconds;
    },
    toTimeString(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        function pad(number) {
            return `${number}`.padStart(2, '0');
        }
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    },
};



// WEBPACK FOOTER //
// ./src/utils/datetime.js